import { Space } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Avatar as StyledAvatar } from 'components/atoms/avatar';
import { Loading } from 'components/atoms/loading';
import { UploadTrigger } from './upload-trigger';

const AvatarLoading = styled(Loading)``;
const AvatarWrapper = styled.div`
  display: inline-block;
  position: relative;

  ${AvatarLoading} {
    position: absolute;
    top: 35px;
    left: 35px;
  }
`;
const Avatar = styled(StyledAvatar)<{ loading?: boolean }>`
  height: 88px;
  margin-right: var(--layout-01);
  opacity: ${({ loading }) => (loading ? 0.4 : 1)};
  width: 88px;

  .ant-avatar-string {
    font-size: var(--heading-5-size);
  }
`;

interface ImageUpload extends UploadTrigger {
  src?: string;
  alt?: string;
  placeholderIcon?: ReactNode;
}

export const ImageUpload: FC<ImageUpload> = ({
  src,
  alt,
  help,
  placeholderIcon,
  buttonText,
  maxSizeInMB,
  isLoading = true,
  isDisabled = false,
  onUpload,
  beforeUpload,
  accept,
  showSizeRestriction,
  showFormatRestriction,
}) => {
  return (
    <Space>
      <AvatarWrapper>
        {isLoading && <AvatarLoading />}
        <Avatar
          size="large"
          name={alt}
          src={src}
          loading={isLoading}
          icon={placeholderIcon}
        />
      </AvatarWrapper>

      <UploadTrigger
        buttonText={buttonText}
        isDisabled={isDisabled}
        isLoading={isLoading}
        help={help}
        onUpload={onUpload}
        beforeUpload={beforeUpload}
        maxSizeInMB={maxSizeInMB}
        accept={accept}
        showSizeRestriction={showSizeRestriction}
        showFormatRestriction={showFormatRestriction}
      />
    </Space>
  );
};
